import React from 'react';
import type { CoreOptions } from '@adyen/adyen-web/dist/types/core/types';

import { useSiteConfig } from 'hooks/useSiteConfig';
import { useTranslate } from 'hooks/useTranslations';
import getAdyenModule from 'utils/adyen';

export const useAdyen = () => {
  const { env, locale, country } = useSiteConfig();

  const t = useTranslate();

  const getAdyenInstance = React.useCallback(
    async (props?: CoreOptions) => {
      const adyen = await getAdyenModule(country);

      const core = await adyen.default({
        locale,
        environment: env.adyenEnv as string,
        clientKey: env.adyenClientKey as string,
        paymentMethodsConfiguration: {
          card: {
            hasHolderName: true,
            holderNameRequired: true,
            positionHolderNameOnTop: true,
          },
          billdesk_online: {
            showPayButton: false,
          },
          onlinebanking_IN: {
            showPayButton: false,
          },
          billdesk_wallet: {
            showPayButton: false,
          },
        },
        translations: {
          [locale]: {
            'creditCard.holderName.placeholder': ' ',
            'creditCard.numberField.placeholder': ' ',
            'creditCard.expiryDateField.placeholder': ' ',
            'creditCard.cvcField.placeholder': ' ',
            'creditCard.cvcField.placeholder.3digits': ' ',
            'creditCard.cvcField.placeholder.4digits': ' ',
            'error.va.sf-cc-dat.01': t('validDate'),
          },
        },
        ...props,
      });

      return core;
    },
    [env.adyenEnv, env.adyenClientKey, locale, t, country]
  );

  return getAdyenInstance;
};
